module.exports = __webpack_public_path__ + "static/media/ils-field-small.78f170d7.svg";